import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ThemeSettingService } from '../services/theme-setting.service';
import { LoginService } from '../services/login.service';
import { NgForm } from '@angular/forms';
import { ConfirmationService } from '../services/confirmation.service';
import { HeaderService } from '../services/header.service';
import { MessagePopupService } from '../services/message-popup.service';
import { WorkflowReturnService } from '../services/workflow-return.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {

  isBusy:boolean = false;
  loaderConfig:any;
  oneTimeKey:string;
  userId:string;
  passwordValue:string = '';
  confirmPasswordValue:string = '';
  valid:boolean = false;
  isPageLoading: boolean = false;
  regexPassword: any;

  @ViewChild('resetPassword') resetPasswordForm:NgForm;

  constructor(private router:Router, private route: ActivatedRoute, private themeSettingService:ThemeSettingService, private loginService:LoginService, 
    private confirmationService:ConfirmationService, private headerService:HeaderService, private messagePopupService: MessagePopupService, private workflowReturnService: WorkflowReturnService) { 
      // this.regexPassword = "^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$";
      this.regexPassword = "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*_=+-]).{8,}$";
    }

  ngOnInit() {
    this.oneTimeKey = this.route.snapshot.paramMap.get('oneTimeKey');
    this.userId = this.route.snapshot.paramMap.get('userId');
    this.loaderConfig = this.themeSettingService.getTheme();
    
    this.headerService.displayMenu(false);

    this.checkOneTimeKey();
  }

  checkOneTimeKey(){
    this.isPageLoading = true;
    this.headerService.validateKey(this.userId, this.oneTimeKey).subscribe(result => {
      this.isBusy = false;
      this.isPageLoading = false;
      if (result){
        this.handleWorkflowReturn(result);
      }
      else{
        this.messagePopupService.popMessage("Error", "One time key is not valid.", ["OK"]).subscribe((respond) => {
        });
      }
    }, error => {
      this.isPageLoading = false;
    })
  }

  submit(password:string, confirmPassword:string){
    if (this.resetPasswordForm.valid){
      this.isBusy = true;
      var param = new Array();
      param.push({ name: 'password', value: password });
      param.push({ name: 'confirmPassword', value: confirmPassword });
      param.push({name: 'key', value: this.oneTimeKey});
      param.push({name: 'userId', value: this.userId})

      this.loginService.resetPassword(param).subscribe(result=>{
        if (result){
          this.handleWorkflowReturn(result);
        }
        this.isBusy = false;
      }, error => {
        this.isBusy = false;
      });
    }
  }

  handleWorkflowReturn(result: any): any {
    var command = JSON.parse(result);
      switch(command.ReturnType){
        case 0: // navigate
          if(command.Arguments){
            var path = [];
            command.Arguments.forEach(element => {
              path.push(element);
            });
            this.router.navigate(path);
          }
          break;
        case 1: //message
          this.pullMessageBox(command);
          break;
        case 2: //reload, does nothing, depends on refreshtype
          break;
        case 3: //open something
          break;
        case 4: //message
          this.pullMessageBox(command);
          break;
        case 8:  //messagenavigate
          this.router.navigate(["/"]);
          this.messagePopupService.popMessage(command.Arguments[0], command.Arguments[1], ["OK"]).subscribe((respond) => {
            if (respond.answer == "OK"){
              this.workflowReturnService.handleNavigateAndMessage(command, false);
            }
          });
        break;
      }
  }

  pullMessageBox(command:any) {
    this.confirmationService.confirm(
      command.Arguments[0],
      command.Arguments[1],
      ['OK'], false, '', false)
      .subscribe((respond) => {
        if (respond.answer == 'OK'){
          this.router.navigate(['/login']);
          this.headerService.displayMenu(true);
        }
      });
  }

  validate(password:any, confirmPassword:any, control:any){
    if (password.value && confirmPassword.value){
      if (password.value != confirmPassword.value){
        this.valid = false;
        this.resetPasswordForm.control.get(control.name).setErrors({noMatch:true});
      }
      else {
        var param = new Array();
        param.push({ name: 'password', value: password.value });
        param.push({ name: 'user', value: this.userId });
        this.loginService.validatePassword(param).subscribe(result=> {
          var object= JSON.parse(result);
          this.resetPasswordForm.control.get("password").setErrors(null);
          this.resetPasswordForm.control.get("confirmPassword").setErrors(null);
          if (object.Arguments[1] != "OK"){
            this.valid = false;
            if (this.resetPasswordForm.control.get(control.name)){
              this.resetPasswordForm.control.get(control.name).setErrors({custom:object.Arguments[1]});
            }
          }
          else{
            this.valid = true;
          }
        })
      }
    }
  }
}
